import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
import { extendedTestimonials } from '../data/testimonials';
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-mist border-y border-mist-dark" data-id="element-81" data-mp="bjmfuaxnuwpf">
      <div className="max-w-6xl mx-auto" data-id="element-82" data-mp="bibgqof5ud4n">
        <div className="text-center mb-16" data-id="element-83" data-mp="gbwecfcud53b">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-navy" data-id="element-84" data-mp="gcxnufe7ljix">
            ⭐ What Coaches Using the System Are Saying
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-85" data-mp="q7pojs338mhx">
          {extendedTestimonials.map((testimonial, index) => <motion.article key={testimonial.role} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-mist-dark p-8 rounded-2xl relative shadow-sm flex flex-col" data-id="element-86" data-mp="u8jaifwyzr86" data-mpi={index}>
              <Quote className="absolute top-6 right-6 text-gold/25" size={48} data-id="element-87" data-mp="380ft6j31i766" />
              <div className="flex gap-1 text-gold mb-6" aria-label="5 out of 5 stars" data-id="element-88" data-mp="37ybed63lrnr4">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" data-id="element-89" data-mp="2z09gv0j2vd8l" data-mpi={starIndex} />)}
              </div>
              <p className="text-slate italic mb-8 relative z-10 leading-relaxed" data-id="element-90" data-mp="3vqa24pk8nbl5">
                “{testimonial.text}”
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-91" data-mp="3rp6sikssabsd">
                <div className="w-12 h-12 rounded-full bg-navy flex items-center justify-center text-white font-bold text-sm shrink-0" data-id="element-92" data-mp="3mo9ac87rxhqv">
                  {testimonial.initials}
                </div>
                <div data-id="element-93" data-mp="2bb6qn4adoc2h">
                  <div className="font-bold text-navy" data-id="element-94" data-mp="2bbq86jw48yfz">{testimonial.name}</div>
                  <div className="text-xs text-azure" data-id="element-95" data-mp="26a111fc0l4x6">{testimonial.role}</div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}